"use client";

import React from "react";
import GenericLazyLoader from "@/components/common/generic-lazy-loader";
import useRelatedBlogs from "@/hooks/product-detail-page/related-blogs/use-related-blogs";
import { RelatedBlogsSection } from "@/types/dto/landing-page/landing-page";

interface RelatedBlogsPdpProps {
  landingPageId: string;
}

const LazyLoadRelatedBlogsPdpSection = ({ landingPageId }: RelatedBlogsPdpProps) => {
  const data = useRelatedBlogs(landingPageId);
  const blogsSection: RelatedBlogsSection = {
    title: "Related Blogs",
    basicInfo: { headerText: "Related Blogs" },
    blogList: data?.data ?? []
  };

  return (
    <GenericLazyLoader
      importComponent={() => import("../related-blogs/related-blogs")}
      componentProps={{ blogSection: blogsSection, moduleRankingPosition: "18" }}
      debugName="Related Blogs Pdp Section"
      threshold={0.1}
      rootMargin="200px 0px"
    />
  );
};

export default LazyLoadRelatedBlogsPdpSection;
